(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const btn = document.getElementById('bundle-add-btn');
  const successMsg = document.getElementById('bundle-success');
  const errorMsg = document.getElementById('bundle-error');

  if (!btn) return;

  btn.addEventListener('click', async function () {

    const mainVariantId = btn.getAttribute('data-main-variant');
    const bundleVariantId = btn.getAttribute('data-bundle-variant');

    if (!mainVariantId || !bundleVariantId) {
      showError();
      return;
    }

    // Button loading state
    btn.disabled = true;
    btn.querySelector('.btn-text').style.display = 'none';
    btn.querySelector('.btn-loading').style.display = 'inline';
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';

    try {
      // Dono products ek saath cart mein add karo
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(mainVariantId),
              quantity: 1
            },
            {
              id: parseInt(bundleVariantId),
              quantity: 1,
              properties: {
                '_bundle_discount': 'yes',
                '_bundle_ref': mainVariantId
              }
            }
          ]
        })
      });

      if (!response.ok) throw new Error('Cart add failed');

      // Success!
      successMsg.style.display = 'block';
      btn.querySelector('.btn-text').textContent = '✅ Cart Mein Hai!';
      btn.querySelector('.btn-text').style.display = 'inline';
      btn.querySelector('.btn-loading').style.display = 'none';

      // Cart count update karo (agar theme mein cart bubble hai)
      updateCartCount();

    } catch (err) {
      console.error('Bundle add error:', err);
      showError();
      btn.disabled = false;
      btn.querySelector('.btn-text').style.display = 'inline';
      btn.querySelector('.btn-loading').style.display = 'none';
    }
  });

  function showError() {
    errorMsg.style.display = 'block';
    setTimeout(() => { errorMsg.style.display = 'none'; }, 4000);
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      // Theme ke cart count elements update karo
      const countEls = document.querySelectorAll(
        '.cart-count, .cart-item-count, [data-cart-count], .header__cart-count'
      );
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch (e) {
      // Cart count update na ho toh bhi chalta hai
    }
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          setupCardSwiping();
          setupSlider();
          setupScrollTrack();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function setupCardSwiping() {
    const swipeTracks = document.querySelectorAll('#complementaryProducts .card-product--image-swipe-track');
    swipeTracks.forEach((swipeTrack) => {
      const leftArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-left');
      const rightArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-right');
      const paginationBullets = swipeTrack
        .closest('.card-product--image-swipe-container')
        .querySelectorAll('.product-card--pagination-bullet');

      const updateArrowState = () => {
        const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
        if (swipeTrack.scrollLeft <= 0) {
          leftArrow.classList.add('faded');
        } else {
          leftArrow.classList.remove('faded');
        }

        if (swipeTrack.scrollLeft >= maxScrollLeft - 2) {
          rightArrow.classList.add('faded');
        } else {
          rightArrow.classList.remove('faded');
        }
      };

      const updatePagination = () => {
        const scrollLeft = swipeTrack.scrollLeft;
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        const activeIndex = Math.round(scrollLeft / slideWidth) + 1;

        paginationBullets.forEach((bullet) => {
          if (parseInt(bullet.dataset.value, 10) === activeIndex) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      };

      const onScroll = () => {
        updateArrowState();
        updatePagination();
      };

      swipeTrack.addEventListener('scroll', onScroll);

      leftArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: -slideWidth,
          behavior: 'smooth',
        });
      });

      rightArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: slideWidth,
          behavior: 'smooth',
        });
      });

      // Initialize states
      updateArrowState();
      updatePagination();
    });
  }

  function setupSlider() {
    const sliderWrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    const sliderContainer = document.querySelector('#complementaryProducts .comp-products-grid');
    const leftArrow = document.querySelector('#complementaryProducts .slider-arrow-left');
    const rightArrow = document.querySelector('#complementaryProducts .slider-arrow-right');

    if (!sliderContainer || !leftArrow || !rightArrow) return;

    const setArrowState = () => {
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;

      // Find the first image element within the slider-grid
      const firstImage = sliderContainer.querySelector('img');
      
      // Get the height of the first image
      const imageHeight = firstImage ? firstImage.clientHeight : 0;

      // Apply top margin to arrows based on half of the image height
      if (sliderWrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }      
      
      if (scrollPosition <= 0) {
        leftArrow.classList.add('disabled');
      } else {
        leftArrow.classList.remove('disabled');
      }

      if (scrollPosition >= scrollLimit - 2) {
        rightArrow.classList.add('disabled');
      } else {
        rightArrow.classList.remove('disabled');
      }
    };

    setArrowState();

    sliderContainer.addEventListener('scroll', setArrowState);
    window.addEventListener('resize', setArrowState);

    leftArrow.addEventListener('click', () => {
      sliderContainer.scrollBy({
        top: 0,
        left: -250,
        behavior: 'smooth',
      });
    });

    rightArrow.addEventListener('click', () => {
      sliderContainer.scrollBy({
        top: 0,
        left: 250,
        behavior: 'smooth',
      });
    });
  }

  // Slider custom scrollbar

  function setupScrollTrack() {
    const wrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    if (wrapper) {
      const slider = wrapper.querySelector('#complementaryProducts .comp-products-grid');
      const track = wrapper.querySelector('.slider-custom-scrollbar-track');
      const marker = wrapper.querySelector('.slider-custom-scrollbar-marker');
    
      if (slider && track && marker) {
        function updateMarkerWidthAndVisibility() {
          const visibleWidth = slider.clientWidth;
          const scrollableWidth = slider.scrollWidth;
    
          if (scrollableWidth <= visibleWidth) {
            track.classList.add('hidden');
          } else {
            track.classList.remove('hidden');
            const trackWidth = track.clientWidth;
            const markerWidth = (visibleWidth / scrollableWidth) * trackWidth;
            marker.style.width = `${markerWidth}px`;
          }
        }
    
        function updateMarkerPosition() {
          const scrollLeft = slider.scrollLeft;
          const scrollableWidth = slider.scrollWidth - slider.clientWidth;
          const trackWidth = track.clientWidth - marker.clientWidth;
    
          const left = (scrollableWidth > 0) ? (scrollLeft / scrollableWidth) * trackWidth : 0;
          marker.style.transform = `translateX(${left}px)`;
        }
    
        // Initial setup
        updateMarkerWidthAndVisibility();
        updateMarkerPosition();
    
        // On scroll
        slider.addEventListener('scroll', updateMarkerPosition);
    
        // On window resize
        window.addEventListener('resize', () => {
          updateMarkerWidthAndVisibility();
          updateMarkerPosition();
        });
      }
    }
  }
  

  } catch(e) { console.error(e); }
})();
})();
